import React, { useEffect, useState } from 'react';
import { OnboardingStageProps, OnboardingUser, SetLoading } from '../../Classes';
import { Button, Field, Header, Input, Message } from 'react-frontier';
import { bindFormChange } from '@tempu/components/Util';
import Validator from '@tempu/components/Validator';
import API from '../../API';

var OnboardingAddress = (props: OnboardingStageProps)=>{
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	
	useEffect(()=>{
		if(!props.user.address){
			props.setUser({
				...props.user,
				address: {
					street: '',
					interior_number: '',
					exterior_number: '',
					neighborhood: '',
					city: '',
					state: '',
					zipcode: '',
					country: 'México'
				}
			})
		}
	}, []);

	var sendInfo = (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(props.user.address, {
			street: [{ rule: 'length', params: [3,64], label: 'Calle' }],
			exterior_number: [
				{ rule: 'empty', label: 'Número exterior' },
				{ rule: 'maxLength', params: [16], label: 'Número exterior' },
			],
			interior_number: [{ rule: 'maxLength', params: [16], label: 'Número interior', skipEmpty: true }],
			neighborhood: [{ rule: 'length', params: [3,64], label: 'Colonia' }],
			city: [{ rule: 'length', params: [3, 64], label: 'Ciudad' }],
			state: [{ rule: 'length', params: [3, 64], label: 'Estado' }],
			zipcode: [{ rule: /[0-9]{5,8}/gi, prompt: 'El código postal no es válido' }],
		});

		setErrorPrompts(prompts);
		if(!valid) return;

		setLoading(true);
		API.onboardingUserAddress(props.user.address).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			props.onFinish();
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado mandando la información (LCL-ONBADD-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	if(!props.user.address) return null;

	var onAddressChange = bindFormChange(props.user.address, v=>{
		return props.setUser({
			...props.user,
			address: v
		});
	});
	
	return <div className='tp onboarding-address'>
		<Header text={'Tu dirección'} subtext={'Compartenos tu dirección de domicilio'} />
		<Message centered style={{ marginBottom: 15 }}>
			Guardamos tu dirección de domicilio de manera segura y solo se usará para validación.
		</Message>
		<Input label='Calle' value={props.user.address.street} onChange={onAddressChange('street')} />
		<Field amount={2}>
			<Input label='Número exterior' value={props.user.address.exterior_number} onChange={onAddressChange('exterior_number')} />
			<Input label='Número interior' value={props.user.address.interior_number} onChange={onAddressChange('interior_number')} />
		</Field>
		<Input label='Colonia' value={props.user.address.neighborhood} onChange={onAddressChange('neighborhood')} />
		<Input label='Ciudad' value={props.user.address.city} onChange={onAddressChange('city')} />
		<Field amount={2}>
			<Input label='Estado' value={props.user.address.state} onChange={onAddressChange('state')} />
			<Input label='Código postal' value={props.user.address.zipcode} onChange={onAddressChange('zipcode')} />
		</Field>

		<Message type='error' list={errorPrompts} />
		<div className="actions">
			<Button text='Continuar' color='black' onClick={sendInfo} />
		</div>
	</div>
}

export default OnboardingAddress;